import { useEffect } from 'react';
import {
  neoAssistCentralSrc,
  NEOASSIST_CLIENT_DOMAIN,
  NEOASSIST_RESTORE_FLOATING_EVENT,
} from '@/lib/neoAssistSdk';

const ENABLE = import.meta.env.VITE_ENABLE_NEOASSIST === 'true';

function unload(): void {
  window.NeoAssistTag = undefined;
  window.NeoAssistTagLoaded = false;
  window._NAWidgetLoaded = [];
  document.getElementById('neoassist-central-loader')?.remove();
  document.querySelector('iframe.neoasssist-widget-frame')?.remove();
  document
    .querySelectorAll('[id*="neoassist-widget-frame"], [class*="neoasssist"]')
    .forEach((el) => el.remove());
}

export function NeoAssistCentral() {
  useEffect(() => {
    if (!ENABLE) return;
    unload();
    window.NeoAssistTag = { querystring: true, pageid: '', clientdomain: NEOASSIST_CLIENT_DOMAIN };
    const script = document.createElement('script');
    script.id = 'neoassist-central-loader';
    script.async = true;
    script.src = neoAssistCentralSrc();
    document.body.appendChild(script);
    return () => {
      unload();
      window.dispatchEvent(new Event(NEOASSIST_RESTORE_FLOATING_EVENT));
    };
  }, []);

  return <div id="NeoassistCentral" />;
}
